import React from "react"
import ReactApexChart from "react-apexcharts"
import PropTypes from "prop-types"

const CarSoldChart = ({ vehicleChart }) => {
  const series = [
    {
      name: "Count",
      data: Object.values(vehicleChart),
    },
  ]

  const options = {
    chart: {
      toolbar: {
        show: true,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "70%",
        endingShape: "rounded",
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#000"],
      },
    },
    stroke: {
      show: true,
      width: 3,
      colors: ["transparent"],
    },

    colors: ["#2784ff"],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: { title: { text: "Sold" } },
    grid: {
      borderColor: "#f1f1f1",
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return " " + val + " Cars"
        },
      },
    },
  }

  return (
    <ReactApexChart options={options} series={series} type="bar" height={320} />
  )
}

export default CarSoldChart

CarSoldChart.propTypes = {
  vehicleChart: PropTypes.array,
}
